<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_238_67)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.6 0H16.4C16.8 0 17.0667 0.133333 17.3333 0.4L23.6 6.66667C23.8667 6.93333 24 7.2 24 7.6V16.4C24 16.8 23.8667 17.0667 23.6 17.3333L17.3333 23.6C17.0667 23.8667 16.8 24 16.4 24H7.6C7.2 24 6.93333 23.8667 6.66667 23.6L0.4 17.3333C0.133333 17.0667 0 16.8 0 16.4V7.6C0 7.2 0.133333 6.93333 0.4 6.66667L6.66667 0.4C6.93333 0.133333 7.2 0 7.6 0ZM10.8 7.2C10.8 6.53726 11.3373 6 12 6C12.6627 6 13.2 6.53726 13.2 7.2V12C13.2 12.6627 12.6627 13.2 12 13.2C11.3373 13.2 10.8 12.6627 10.8 12V7.2ZM12 18C12.6627 18 13.2 17.4627 13.2 16.8C13.2 16.1372 12.6627 15.6 12 15.6C11.3373 15.6 10.8 16.1372 10.8 16.8C10.8 17.4627 11.3373 18 12 18Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_238_67">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
